export const API_URL = import.meta.env.VITE_API_URL || "https://lingosound-api.lingosoundlatam.workers.dev";

export interface User {
  id: string;
  name: string;
  email: string;
  plan: "xr4" | "pro" | "business";
}

export interface License {
  productSku: string;
  status: "active" | "suspended" | "revoked";
  deviceId: string;
  activatedAt: string;
}

export interface AccountSnapshot {
  user: User;
  license: License | null;
  usage: { characters: number; requests: number; estimated_cost_micro_usd: number };
  limits: {
    monthlyCharacters: number;
    dailySpeechSessions: number;
    speechSessionsUsed: number;
    voiceSessionMinutes: number;
  };
}

export class ApiError extends Error {
  constructor(message: string, public readonly code: string, public readonly status: number) {
    super(message);
  }
}

export async function apiRequest<T>(path: string, options: RequestInit = {}, token?: string | null): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  if (token) headers.set("Authorization", `Bearer ${token}`);
  let response: Response;
  try {
    response = await fetch(`${API_URL}${path}`, { ...options, headers });
  } catch {
    throw new ApiError("No pudimos conectar con LingoSound. Revisá tu conexión.", "network_error", 0);
  }
  const payload = await response.json().catch(() => ({})) as { error?: string; code?: string } & T;
  if (!response.ok) {
    throw new ApiError(payload.error || "Ocurrió un error", payload.code || "request_failed", response.status);
  }
  return payload;
}
